var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voice-call"},[_c('vue-webrtc',{ref:'webrtc',attrs:{"socketURL":'https://weston-vue-webrtc-lobby.azurewebsites.net',"roomId":_vm.room,"enableAudio":true,"enableVideo":false,"autoplay":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }